<script setup>
import SiteLayout from '@/Layouts/Layout.vue';
import SpfPolicyTestForm from '@/Pages/SpfPolicyTest/Partials/SpfPolicyTestForm.vue';
import { usePage } from '@inertiajs/vue3';

const { name } = usePage().props.branding;
</script>

<template>
  <SiteLayout
    :title="$t('spf_policy_test.index.spf_policy_test_tool')"
    :description="$t('spf_policy_test.index.description', { name: name })"
  >
    <SpfPolicyTestForm />
  </SiteLayout>
</template>
